import { useFormItemControl } from '@components/form/useFormItemControl'
import { useAnswer } from '@contexts/AnswerContext'
import { AssociatedAnswer } from '@models/Form'
import { Flex, SpaceProps, Typography } from 'antd'
import { FC } from 'react'

const { Text } = Typography

interface AssociatedAnswersPreviewProps {
  spaceStyle?: SpaceProps['style']
}

const AssociatedAnswersPreview: FC<AssociatedAnswersPreviewProps> = ({
  spaceStyle,
}) => {
  const { item } = useAnswer()
  const { associatedAnswers } = item || {}

  if (!associatedAnswers || associatedAnswers.length === 0) {
    return <></>
  }

  return (
    <Flex vertical className="w-full" style={spaceStyle}>
      {associatedAnswers.map((associatedAnswer, index) => (
        <AssociatedAnswerPreview
          key={index}
          associatedAnswer={associatedAnswer}
        />
      ))}
    </Flex>
  )
}

const AssociatedAnswerPreview: FC<{
  associatedAnswer: AssociatedAnswer
}> = ({ associatedAnswer }) => {
  const { content } = useFormItemControl({
    item: associatedAnswer.item,
    isFulfilled: true,
  })

  if (
    (associatedAnswer.answer === null ||
      associatedAnswer.answer === undefined ||
      associatedAnswer.answer === '') &&
    associatedAnswer.options.length === 0
  ) {
    /**
     * No associated answer to display
     * This could be wether because the employee did not answer the question
     * or because it's the first time the employee is filling the form and there are no previous answers
     */
    return <></>
  }

  return (
    <div
      style={{
        backgroundColor: 'rgba(217, 217, 217, 0.2)',
        borderRadius: '10px',
        padding: '12px',
        marginTop: '8px',
      }}
    >
      <Text
        type="secondary"
        style={{
          fontSize: '14px',
          lineHeight: '22px',
          display: 'block',
          whiteSpace: 'pre-wrap',
        }}
      >
        Réponse à la campagne {associatedAnswer?.campaign}
      </Text>
      <Text
        type="secondary"
        style={{
          fontSize: '14px',
          lineHeight: '22px',
          display: 'block',
          whiteSpace: 'pre-wrap',
        }}
      >
        {content(associatedAnswer.answer, associatedAnswer.options)}
      </Text>
    </div>
  )
}

type AssociatedAnswersPreviewType = {
  AssociatedAnswersPreview: typeof AssociatedAnswersPreview
}

export { AssociatedAnswersPreview, type AssociatedAnswersPreviewType }
